document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll("[data-animate-percentage]");

  if (!items.length) return;

  function animateValue(el, endValue, duration = 1500) {
    let startTime = null;
    const startValue = 0;

    function update(currentTime) {
      if (!startTime) startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / duration, 1);
      const currentValue = Math.floor(
        progress * (endValue - startValue) + startValue,
      );

      el.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = endValue;
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const percentageEl = entry.target.querySelector("[data-percentage]");
        if (!percentageEl || percentageEl.dataset.animated === "true") return;

        const finalValue = parseInt(percentageEl.dataset.percentage, 10) || 0;

        percentageEl.dataset.animated = "true";
        animateValue(percentageEl, finalValue);

        obs.unobserve(entry.target);
      });
    },
    {
      threshold: 0.4,
    },
  );

  items.forEach((item) => observer.observe(item));
});
